// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"738984a3","845":"865ae5dd"}[chunkId] + ".chunk.js";
};